import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex h-full relative overflow-hidden" }
const _hoisted_2 = { class: "flex flex-col h-full flex-1 min-w-0 relative" }
const _hoisted_3 = {
  key: 1,
  class: "absolute bottom-20 left-1/2 transform -translate-x-1/2 z-20"
}
const _hoisted_4 = {
  key: 2,
  class: "absolute z-10 left-0 top-0 w-full"
}

import Cookies from 'js-cookie'
import Pusher from 'pusher-js'
import { ulid } from 'ulid'
import { computed, onBeforeMount, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import Alert from '@/components/Alert'
import CustomerSmsSimulator from '@/components/customers/CustomerSmsSimulator'
import privilegeService from '@/services/privilege.service'
import { mapRelationship } from '@/store/mappers'

const REVELIO_WORD = 'revelio'

export default {
  __name: 'MessagesTab',
  setup(__props) {

const store = useStore()
const route = useRoute()

const data = reactive({
  alertStatus: '',
  alertMsg: '',
  channel: null,
  showNewMessagesButton: false,
  newMessageCount: 0,
  isScrolledToBottom: true
})

const messageStreamRef = ref(null)

const conversationUserPair = computed(() => mapRelationship({ type: 'conversation_user_pair', id: route.params.id }))

const name = computed(() => conversationUserPair.value?.attributes?.display_name)

const canCreateMessages = computed(() => {
  return privilegeService.canAccessResourceAction('messages', null, 'create')
})

const canUpdateMessages = computed(() => {
  return privilegeService.canAccessResourceAction('messages', null, 'update')
})

const isDev = process.env.NODE_ENV === 'development'
const simulatorOpen = ref(false)
const customerPhone = computed(() => conversationUserPair.value?.attributes?.user_phone_active || '')

let revelioBuffer = ''

const onRevelioKeydown = e => {
  const el = e.target
  const tag = el && el.tagName ? el.tagName.toLowerCase() : ''
  if (tag === 'input' || tag === 'textarea' || (el && el.isContentEditable)) return
  if (e.key === 'Escape') {
    simulatorOpen.value = false
    revelioBuffer = ''
    return
  }
  if (!e.key || e.key.length !== 1) return
  revelioBuffer = (revelioBuffer + e.key.toLowerCase()).slice(-REVELIO_WORD.length)
  if (revelioBuffer === REVELIO_WORD) {
    simulatorOpen.value = true
    revelioBuffer = ''
  }
}

onBeforeMount(() => {
  if (!store.state.pusher) {
    store.commit(
      'SET_PUSHER',
      new Pusher(process.env.VUE_APP_PUSHER_KEY, {
        authEndpoint: process.env.VUE_APP_API_SERVER + 'pusher/auth'
      })
    )
  }
  data.channel = store.state.pusher.subscribe('u' + store.getters.loggedInUserId)
})

onMounted(() => {
  if (isDev) window.addEventListener('keydown', onRevelioKeydown)
})

onUnmounted(() => {
  store.state.pusher.unsubscribe(data.channel.name)
  if (isDev) window.removeEventListener('keydown', onRevelioKeydown)
})

const uploadFile = file => {
  const key = 'message_' + ulid()

  const reader = new FileReader()
  reader.onload = e => {
    store.commit('ADD_PENDING_MESSAGE', {
      message: {
        src: e.target.result,
        object_key: key
      },
      id: route.params.id
    })
  }
  reader.readAsDataURL(file)

  const formData = new FormData()
  formData.append('message[file]', file)
  formData.append('message[object_key]', key)

  fetch(process.env.VUE_APP_API_SERVER + `conversation_user_pairs/${route.params.id}/messages`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${Cookies.get('auth_token')}`,
      Accept: 'application/json'
    },
    body: formData
  }).catch(() => {
    data.alertStatus = 'error'
    data.alertMsg = 'Upload failed'
  })
}

const uploadFiles = files => {
  files.forEach(x => uploadFile(x))
}

const onScrollPositionChanged = isAtBottom => {
  data.isScrolledToBottom = isAtBottom
  if (isAtBottom) {
    data.showNewMessagesButton = false
    data.newMessageCount = 0
  }
}

const onNewMessageWhileScrolled = count => {
  data.newMessageCount = count
  data.showNewMessagesButton = true
}

const scrollToBottom = () => {
  if (messageStreamRef.value) {
    messageStreamRef.value.scrollToBottom()
    data.showNewMessagesButton = false
    data.newMessageCount = 0
  }
}

return (_ctx, _cache) => {
  const _component_message_stream = _resolveComponent("message-stream")
  const _component_message_bar = _resolveComponent("message-bar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_component_message_stream, {
        ref_key: "messageStreamRef",
        ref: messageStreamRef,
        key: _unref(route).params.id,
        channel: data.channel,
        class: "overflow-y-auto h-full",
        onSubmitFiles: uploadFiles,
        onScrollPositionChanged: onScrollPositionChanged,
        onNewMessageWhileScrolled: onNewMessageWhileScrolled
      }, null, 8, ["channel"])),
      (canCreateMessages.value)
        ? (_openBlock(), _createBlock(_component_message_bar, {
            key: 0,
            onSubmitFiles: uploadFiles
          }))
        : _createCommentVNode("", true),
      (data.showNewMessagesButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "bg-blue-600 hover:bg-blue-700 text-gray-100 px-4 py-2 rounded-2xl shadow-lg text-sm font-medium transition-colors duration-200 flex items-center space-x-2",
              onClick: scrollToBottom
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 14l-7 7m0 0l-7-7m7 7V3"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(data.newMessageCount) + " new message" + _toDisplayString(data.newMessageCount === 1 ? '' : 's'), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (data.alertMsg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(Alert), {
              status: data.alertStatus,
              msg: data.alertMsg,
              onClosed: _cache[0] || (_cache[0] = $event => (data.alertMsg = ''))
            }, null, 8, ["status", "msg"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (isDev && simulatorOpen.value)
      ? (_openBlock(), _createBlock(_unref(CustomerSmsSimulator), {
          key: 0,
          "conversation-user-pair-id": _unref(route).params.id,
          "customer-name": name.value,
          "customer-phone": customerPhone.value,
          onClose: _cache[1] || (_cache[1] = $event => (simulatorOpen.value = false))
        }, null, 8, ["conversation-user-pair-id", "customer-name", "customer-phone"]))
      : _createCommentVNode("", true)
  ]))
}
}

}